import React from "react";
import { DataSnapshot } from "../api/firebase";
import { useSnapshotState } from "../api/firebaseHooks";
import { useOrderStrings } from "./order-strings";

export default function OrderItemRemarkPopUp({ snapshot }: OrderItemRemarkPopUpProps) {

    const orderStrings = useOrderStrings();
    const [orderItemRemark, setOrderItemRemark] = useSnapshotState<string>(snapshot, 'orderItemRemark');

    const onRemarkChanged = (value: string) => {
        !!value ? setOrderItemRemark(value) : snapshot.ref.child('orderItemRemark').remove();
    }

    return <div className='order-remarks-box'>
        <textarea className='popup-order-item-remark' placeholder={orderStrings.orderItemRemarksPlaceholder} value={orderItemRemark ?? ""} onChange={e => onRemarkChanged(e.target.value)} />
    </div>

}

type OrderItemRemarkPopUpProps = {
    snapshot: DataSnapshot; // Food item
}